import XLSX from 'xlsx';

const moment = require('moment');

const headers = [
  'name',
  'numberInProduct',
  'percentageShow',
  'modeActions',
  'ingredients',
  'numberInPatent',
  'themes',
  'parentSegmentations',
  'subSegmentations',
];
const cols = [
  { width: 25 },
  { width: 15 },
  { width: 15 },
  { width: 15 },
  { width: 15 },
  { width: 50 },
  { width: 50 },
  { width: 50 },
  { width: 50 },
];

export default {
  methods: {
    async exportRoleView(roles, nbProducts) {
      // /* convert state to workbook */
      const ws = XLSX.utils.aoa_to_sheet(
        await this.createXLSData(roles, nbProducts),
      );

      /* Set worksheet sheet to "wide" */
      ws['!margins'] = {
        left: 1.0,
        right: 1.0,
        top: 1.0,
        bottom: 1.0,
        header: 0.5,
        footer: 0.5,
      };
      ws['!cols'] = cols;

      let i;
      for (i in ws) {
        /* all keys that do not begin with "!" correspond to cell addresses */
        if (i.indexOf('!') === -1) {
          ws[i].s = {
            alignment: {
              wrapText: 1, // any truthy value here
            },
          };
        }
      }
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'SheetJS');
      const fileName = `Export vue rôle_${moment().format('DD/MM/YYYY')}.xlsx`;
      /* generate file and send to client */
      XLSX.writeFile(wb, fileName);
    },
    async createXLSData(roles, nbProducts) {
      try {
        const data = [this.excelHeaders(nbProducts)];

        Object.entries(roles).forEach(([name, role]) => {
          data.push([
            name,
            role.numberInProduct,
            Math.round(role.percentageShow * 10000) / 100,
            this.getValuesFromOject(role.modeActions).join('; '),
            this.getValuesFromOject(role.ingredients).join('; '),
            role.numberInPatent,
            this.getValuesFromOject(role.themes).join('; '),
            this.getValuesFromOject(role.parentSegmentations).join('; '),
            this.getValuesFromOject(role.subSegmentations).join('; '),
          ]);
        });
        return data;
      } catch (err) {
        console.log(err);
        return null;
      }
    },
    transformObjectToArray(roles) {
      const data = [];
      Object.entries(roles).forEach(([name, role]) => {
        data.push([
          name,
          role.numberInProduct,
          Math.round(role.percentageShow * 10000) / 100,
          this.getValuesFromOject(role.modeActions).join('; '),
          this.getValuesFromOject(role.ingredients).join('; '),
          role.numberInPatent,
          this.getValuesFromOject(role.themes).join('; '),
          this.getValuesFromOject(role.parentSegmentations).join('; '),
          this.getValuesFromOject(role.subSegmentations).join('; '),
        ]);
      });
      return data;
    },
    transformObjectToArrayV2(roles) {
      const data = [];
      Object.entries(roles).forEach(([name, role]) => {
        data.push([
          name,
          role.numberInProduct,
          Math.round(role.percentageShow * 10000) / 100,
          this.getValuesFromOjectV2(role.modeActions),
          this.getValuesFromOjectV2(role.ingredients),
          role.numberInPatent,
          this.getValuesFromOjectV2(role.themes),
          this.getValuesFromOjectV2(role.parentSegmentations),
          this.getValuesFromOjectV2(role.subSegmentations),
        ]);
      });
      return data;
    },
    getValuesFromOject(object) {
      const values = [];
      Object.entries(object).forEach(([name, value]) => {
        values.push(`${name} (${value})`);
      });
      return values;
    },
    getValuesFromOjectV2(object) {
      const values = [];
      Object.entries(object).forEach(([name, value]) => {
        values.push({ name, count: value });
      });
      return values;
    },
    excelHeaders(nbProducts) {
      const headerLabels = [];

      headers.forEach((header) => {
        headerLabels.push(
          header === 'numberInProduct' && nbProducts ? `${this.labels.exportRoleView[header]} - ${this.labels.export_total_product_selected.replace('%nb%', nbProducts)}` : this.labels.exportRoleView[header],
        );
      });
      return headerLabels;
    },
  },
};



// WEBPACK FOOTER //
// ./src/assets/js/exportRoleView.js